import styled from 'styled-components';
import { VariablePill } from './VariablePill';
import { clickablePillCss } from './clickablePillCss';

export const Styled = styled(VariablePill)<{ $clickable?: boolean; $unpopulated?: boolean; $bordered?: boolean }>`
  ${({ $clickable, $unpopulated, $bordered }) => $clickable && clickablePillCss($unpopulated, $bordered)}
`;
